// The public config from GET /config, held once the shell has fetched it, for
// views that need something from it other than auth (which authState owns) —
// today, the community portal's origin for share links.

/** @type {object|null} */
let appConfig = null;

/** @param {object} config the body of GET /config */
export function setAppConfig(config) {
    appConfig = config;
}

/** @returns {object} the config, or an empty object before the shell has loaded it */
export function getAppConfig() {
    return appConfig ?? {};
}
